module.exports = __webpack_public_path__ + "img/icon-14.b0f89b41.png";